import React, { useContext, useEffect, useRef } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './AdditionalSettings.module.scss';

const AdditionalSettings: React.FC = () => {
	const { styleData, selectedStyleGroup } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const headingElement = useRef<null | HTMLDivElement>(null);

	useEffect(() => {
		if (selectedStyleGroup?.id === 'additionalSettingFileID') {
			headingElement.current?.scrollIntoView({ behavior: 'smooth' });
		}
	}, [selectedStyleGroup]);

	return (
		<div className={style.container} ref={headingElement}>
			<BlobDownloader
				filePath={styleData?.additionalSetting.filePath ? styleData.additionalSetting.filePath : null}
				fileExtension="json"
				fileName="additional_settings"
				label="downloadSettings"
			/>
		</div>
	);
};

export default AdditionalSettings;
